import { render } from "./ConversionLeads.vue?vue&type=template&id=37afddb6&scoped=true&ts=true&lang=pug"
import script from "./ConversionLeads.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConversionLeads.vue?vue&type=script&lang=ts&setup=true"

import "./ConversionLeads.vue?vue&type=style&index=0&id=37afddb6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37afddb6"]])

export default __exports__